import { GenericLoader } from "./GenericLoader";

export const createMarketplaceLoader = (loaderConfig) => {
    if (!loaderConfig) return null;

    return () => (
        <GenericLoader
            logo={loaderConfig.logo}
            width={loaderConfig.width}
            height={loaderConfig.height}
        />
    );
}; 